import { render, staticRenderFns } from "./AccountManage.vue?vue&type=template&id=4252425a&scoped=true&"
import script from "./AccountManage.vue?vue&type=script&lang=js&"
export * from "./AccountManage.vue?vue&type=script&lang=js&"
import style0 from "./AccountManage.vue?vue&type=style&index=0&id=4252425a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252425a",
  null
  
)

export default component.exports